import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "ce20a81f-b003-4a9e-aa61-8d57419776a5",
  title: "Hal Higdon: Intermediate 2",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "11 miles",
      totalDistance: 11,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "13 miles",
      totalDistance: 13,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "14 miles",
      totalDistance: 14,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles pace",
      totalDistance: 7,
    },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles pace",
      totalDistance: 8,
    },
    {
      description: "16 miles",
      totalDistance: 16,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "17 miles",
      totalDistance: 17,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "13.1 miles Half Marathon",
      totalDistance: 13.1,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "9 miles pace",
      totalDistance: 9,
    },
    {
      description: "19 miles",
      totalDistance: 19,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles pace",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles pace",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles pace",
      totalDistance: 4,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    { description: "Cross", totalDistance: 0 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "2 miles run",
      totalDistance: 2,
    },
    { description: "Marathon", totalDistance: 26.2 },
  ],
} as BuiltInPlan;